import React, { useState } from "react";
import { useAppContext } from "../contexts/AppContext";

const TaskForm = () => {
  const { addTask } = useAppContext();
  const [title, setTitle] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    addTask({ title });
    setTitle("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Task Title"
        required
      />
      <button type="submit">Add Task</button>
    </form>
  );
};

export default TaskForm;
